module.exports = __webpack_public_path__ + "img/nathan-dumlao-zUNs99PGDg0-unsplash.e8f2da51.png";